import Toolbar from '@mui/material/Toolbar'
import { NAV_LEFT_WRAP } from 'shared/components/Nav/NavLeft'
import { Colors } from 'shared/theme/colors'
import { styled } from 'styled-components'

import { AppCompanyBrand } from './AppCompanyBrand'
import { brandedNavigation, NavigationBrand } from './BrandedNavigation.styles'

export const BasicNav = () => {
  return (
    <StyledToolbar>
      <NavigationBrand>
        <AppCompanyBrand />
      </NavigationBrand>
      <div id={NAV_LEFT_WRAP} />
    </StyledToolbar>
  )
}

const StyledToolbar = styled(Toolbar)`
  background-color: ${Colors.white};
  justify-content: space-between;
  min-height: 64px;
  max-width: 1440px;
  margin: auto;
  ${brandedNavigation}
`
